import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_02 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '2' }));
  }, []);

  console.log('ntsResult>>', ntsResult);
  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>인원별 합계</p>
        <Table01 ntsResult={ntsResult} />
      </div>
      <div className={'ntsResultBox02'}>
        <div className={'ntsResultBox'}>
          <p className={'body2Bold subPoint3 ntsResultTitle'}>의료비 입력 상세 내역</p>
          <Table02 ntsResult={ntsResult} />
        </div>
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>실손의료보험금 입력 상세 내역</p>
        <Table03 ntsResult={ntsResult} />
      </div>
    </div>
  );
};

export default NtsResult_02;

const Table01 = ({ ntsResult }) => {
  const headList = [
    // { name: "순번", key: "", width: "70px" },
    { name: '성명', key: 'htmPerNm', width: '50%' },
    { name: '주민등록번호', key: 'htmRegNum', width: '233.33px' },
    { name: '합계', key: 'sum', width: '50%', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map((item, index) => (
        <div key={index} className="displayFlex tableTr">
          {headList.map((header, _index) => (
            <div
              className="tableBody captionMedium"
              key={_index}
              style={{ justifyContent: header.align }}>
              {item[header.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '환자', key: 'htmPerNm', width: '15%' },
    { name: '환자 주민번호', key: 'htmRegNum', width: '25%' },
    { name: '월', key: 'htmMm2', width: '10%' },
  ];

  const headListGroup2 = [
    { name: '상호', key: 'htm004', width: '25%' },
    { name: '사업자번호', key: 'htm003', width: '105px' },
    { name: '납입금액', key: 'htm001', width: '25%', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  // width: item.width,
                  // flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.list?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    // width: header.width,
                    // flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table03 = ({ ntsResult }) => {
  const headList = [
    { name: '주피보험자', key: 'htm011', width: '15%' },
    { name: '주피보험자 주민번호', key: 'htm010', width: '20%' },
    { name: '계약자	', key: 'htmPerNm', width: '15%' },
    { name: '계약자 주민번호', key: 'htmRegNum', width: '20%' },
    { name: '상호', key: 'htm004', width: '15%' },
    { name: '납입금액', key: 'htm001', width: '15%', align: 'right' },
    // { name: '반영유무	', key: 'htmDesc1', width: '63px' },
    // { name: '사유', key: 'htmDesc2', width: '38px' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div className="tableTitle captionBold" key={index}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.list?.map(
        (item, index) =>
          item?.htm002?.includes('실손') && (
            <div key={index} className="displayFlex tableTr">
              {headList.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{ justifyContent: header.align }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
};
